import axios from "axios";
const url_api=process.env.REACT_APP_API_URL;

const configureAxios={
    headers: {
      'content-Type': 'multipart/form-data'
    }
  }
  const configureAxioB={
    headers: {
      'content-Type': 'image/jpeg'
    }
  }
const CenterService={
    getAllCenters: async()=>{
        try {
            const response=await axios.get(url_api+"/center");
            return response;
        } catch (error) {
            return error;
        }
    },
    postCenter: async(center)=> {
        try {
            const response= await axios.post(url_api+"/center/creationcenter",center);
            return response;
        } catch (error) {
            return error;
        }
    },
    updateCenter: async(center)=>{
        try {
            const centerId=center.id;
            const response= await axios.put(url_api+"/center/updatecenter/"+centerId,center);
            return response;
        } catch (error) {
            return error;   
        }

    },
    getCenterById: async(centerId)=>{
        try {
            const response= await axios.get(url_api+"/center/getonecenter/"+centerId);
            return response;
        } catch (error) {
            return error;
        }
    },
    deleteCenterById: async(centerId)=>{
        try {
            const response= await axios.delete(url_api+"/center/deletecenter/"+centerId);
            return response;
        } catch (error) {
            return error;
        }
    },
    getListCentersByRegister: async(InstituteId)=>{
        try {
            const response= await axios.get(url_api+"/center/getlistcenters/"+InstituteId);
            return response;
        } catch (error) {
            return error;
        }
    },
    checkDataByCenterForDeleted: async(centerId)=>{
        try{
            const verification=await axios.get(url_api+"/center/checkdatabycenter/"+centerId)
            return verification;
        }catch(error){
            return error
        }
    },
    getCenterDataByCenter:async(centerId)=>{
        try{
            const centerData=await axios.get(url_api+"/center/"+centerId+"/centerdata/")
            return centerData;
        }catch(error){
            return error
        }
    },
    createCenterDataByCenter:async(centerId,newCenterData)=>{
        try{
            const centerData=await axios.post(url_api+"/center/"+centerId+"/centerdata/create",newCenterData)
            return centerData;
        }catch(error){
            return error
        }
    },
    updateCenterDataByCenter:async(centerId,newCenterData)=>{
        try{
            const centerData=await axios.put(url_api+"/center/"+centerId+"/centerdata/update",newCenterData)
            return centerData;
        }catch(error){
            return error
        }
    },
    transferToUserAnotherCenter:async(userId,updateCenter)=>{
        try {
            console.log("userId",userId,"updateCenter",updateCenter)
            const centerData=await axios.put(url_api+"/center/transfercenter/user/"+userId,updateCenter)
            return centerData;
        } catch (error) {
            return error;
        }
    },
    createDocumentApproval:async(documentApproval,CenterId,UserUpate)=>{
        try {
            const documentApprovalCenter=await axios.post(url_api+"/center/"+CenterId+"/registerdocumentapprovalby/"+UserUpate,documentApproval,configureAxios)
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },
    updateDocumentApproval:async(documentApproval,CenterId,UserUpate)=>{
        try {
            const documentApprovalCenter=await axios.put(url_api+"/center/"+CenterId+"/updatedocumentapprovalby/"+UserUpate,documentApproval,configureAxios)
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },
    getDocumentApprovalByCenter:async(CenterId)=>{
        try {
            const documentApprovalCenter=await axios.get(url_api+"/center/"+CenterId+"/getdocumentapprovalByCenter/")
            return documentApprovalCenter;
        } catch (error) {
            return error;
        }
    },

    getListCentersByInstitute:async(InstituteId)=>{
        try {
            const ListCenters=await axios.get(url_api+"/center/listcentersbyinstitute/"+InstituteId)
            return ListCenters;
        } catch (error) {
            return error;
        }
    },

    updateLogoByCenter:async(logoCenter,CenterId)=>{
        try {
            // console.log(logoCenter.get("logoCenter"))
            const center=await axios.put(url_api+"/center/"+CenterId+"/updatelogo/",logoCenter,configureAxioB)
            return center;
        } catch (error) {
            return error;
        }
    },

    getLogoByCenter:async(CenterId)=>{
        try {
            const center=await axios.get(url_api+"/center/imagelogocenter/"+CenterId)
            return center;
        } catch (error) {
            return error;
        }
    },
    
    getAllCentersWithoutInstitute: async()=>{
        try {
            const response=await axios.get(url_api+"/center/listcenterswithoutinstitute");
            return response;
        } catch (error) {
            return error;
        }
    },
}
export default CenterService;